import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import AppointmentContext from '@/product/context/appointment/appointmentContext'
import { Button, ListItem } from '@mui/material'
import { LinearProgress } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import moment from 'moment'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import { dateFormatFrontOnlyDate } from '@/custom/common/components'
import './AppointmentManage.css'
import Loaders from '@/product/components/molecules/Loaders'
import { values } from 'underscore'

const today = new Date()
const tomorrow = new Date(today.getTime() + 1 * 24 * 3600000)
const twodays = new Date(today.getTime() + 2 * 24 * 3600000)
const threedays = new Date(today.getTime() + 3 * 24 * 3600000)
const oneweek = new Date(threedays.getTime() + 7 * 24 * 3600000)

const AppointmentManage = (props) => {
    const appointmentContext = useContext(AppointmentContext)
    const {
        all_appointments_auction,
        single_appointment,
        getSingleAppointment,
        getAppointmentForInvoice,
        getAllAppointmentsForAuction,
        updateAppointment,
        responseStatus: responseStatusAppointment,
        clearResponse: clearResponseAppointment,
    } = appointmentContext
    const [isLoading, setIsLoading] = useState(false)
    const [allAvailableTime, setAllAvailableTime] = useState([])
    const [customDate, setCustomDate] = useState(false)
    const [dateCalendar, setDateCalendar] = useState(false)

    const data = props.data
    const toggleFullScreenPopup = props.function

    const validationArray = Yup.object({
        pickupTime: Yup.string().when(['local_pickup_check', 'pickupDay'], {
            is: (a, b) => a === 1 && b,
            then: Yup.string().required('Appointment time is required!'),
        }),
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            invoice_id: 0,
            auction_id: 0,
            user_id: 0,
            status: '',
            pickupDay: '',
            pickupTime: '',
            notes: '',
            local_pickup_check: false,
        },
        enableReinitialize: true,
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            let appointmentTime = null
            if (values.pickupDay && values.pickupTime) {
                let pickupChanged = values.pickupDay + ' ' + values.pickupTime
                appointmentTime = moment(
                    pickupChanged,
                    'MM-DD-YYYY HH:mm'
                ).format()
            }
            if (appointmentTime) {
                values = {
                    ...values,
                    appointmentTime,
                }
                if (data.status === 'new') updateAppointment(values)
            }
            if (data.status === 'edit') updateAppointment(values)
        },
    })
    useEffect(() => {
        setIsLoading(false)
    }, [])
    useEffect(() => {
        if (data.status === 'edit') {
            setIsLoading(true)
            resetFrom()
            formik.values.id = data.id
            getSingleAppointment({
                page: 1,
                limit: 1,
                filters: {
                    aid: {
                        field: 'a.id',
                        type: 'in',
                        value: formik.values.id,
                    },
                    valid: {
                        field: 'a.status',
                        type: 'notin',
                        value: 'open',
                    },
                },
            })
        } else if (data.status === 'new') {
            formik.values.invoice_id = data.invoice_id
            getAppointmentForInvoice({
                invoice_id: data.invoice_id,
            })
        } else {
            resetFrom()
        }
    }, [data])

    useEffect(() => {
        if (
            single_appointment.records &&
            single_appointment.records.length > 0
        ) {
            const appointment = single_appointment.records[0]
            if (data.status === 'edit') {
                formik.setValues({
                    id: appointment.id,
                    status: appointment.status,
                    local_pickup_check: appointment.local_pickup_check,
                    notes: appointment.notes,
                })
            }
            if (data.status === 'new') {
                formik.setValues({
                    id:
                        appointment.appointment_id > 0
                            ? appointment.appointment_id
                            : 0,
                    auction_id: appointment.auction_id,
                    invoice_id: appointment.common_invoice,
                    user_id: appointment.user_id,
                    local_pickup_check: appointment.local_pickup_check,
                })
            }
            getAllAppointmentsForAuction({
                filters: {
                    auction_id: {
                        field: 'a.auction_id',
                        type: 'in',
                        value: appointment.auction_id,
                    },
                    valid: {
                        field: 'a.status',
                        type: 'notin',
                        value: 'open',
                    },
                },
                groupby: 'a.id',
            })
        } else {
            resetFrom()
        }
        setIsLoading(false)
    }, [single_appointment])

    const resetFrom = () => {
        formik.values.pickupDay = ''
        formik.values.pickupTime = ''
        formik.handleReset()
        setIsLoading(false)
    }

    const statusOptions = [
        { show: 'Unfulfilled', value: 'booked' },
        { show: 'Ready for pickup', value: 'ready_for_pickup' },
        { show: 'Picked Up', value: 'picked_up' },
        { show: 'Shipped', value: 'shipped' },
        { show: 'Partial Pickup', value: 'partial_pickup' },
        { show: 'No Show', value: 'no_show' },
    ]
    const EditAppointment = {
        formik: formik,
        data: [
            {
                label: 'Status',
                placeholder: 'Select Status',
                type: 'select',
                class: 'col-sm-6 col-12',
                options: statusOptions,
                defaultOptionValue: 'Select a Status',
                name: 'status',
                formik: formik,
            },
            {
                label: 'Notes',
                placeholder: 'Enter Notes',
                type: 'text',
                class: 'col-sm-6 col-12',
                name: 'notes',
                formik: formik,
            },
        ],
    }

    const formSubmit = (e) => {
        formik.handleSubmit(e)
    }

    function intervals(startString, endString) {
        const intervalMinutes =
            single_appointment.records?.[0]?.local_pickup_slot_timeframe || 30
        var start = moment(startString, 'YYYY-MM-DD HH:mm')
        var end = moment(endString, 'YYYY-MM-DD HH:mm')
        start.minutes(
            Math.ceil(start.minutes() / intervalMinutes) * intervalMinutes
        )
        var result = []
        var current = moment(start)
        while (current < end) {
            result.push({
                value: moment(current).format('HH:mm'),
                show: `${current.format('h:mm a')}`,
            })
            current.add(intervalMinutes, 'minutes')
        }
        return result
    }

    useEffect(() => {
        const selectedDate = moment(
            formik.values.pickupDay,
            'MM-DD-YYYY'
        ).format()
        let weekDate = parseInt(moment(selectedDate).format('d'))
        let validDate = single_appointment.records
            ?.at(0)
            ?.local_pickup_dates?.split(',')
            .filter(
                (d) =>
                    d ===
                    moment(formik.values.pickupDay, 'MM-DD-YYYY')
                        .format()
                        .split('T')[0]
            )
        if (weekDate !== null && validDate && validDate.length > 0) {
            setCustomDate(true)
            let dateSelected = moment(
                formik.values.pickupDay,
                'MM-DD-YYYY'
            ).format('YYYY-MM-DD')
            let timeMinimum = moment(
                single_appointment.records?.[0]?.local_pickup_start_hour,
                'HH:mm a'
            ).format('HH:mm')
            let timeMaximum = moment(
                single_appointment.records?.[0]?.local_pickup_end_hour,
                'HH:mm a'
            ).format('HH:mm')
            timeMinimum = moment(dateSelected + ' ' + timeMinimum).format()
            timeMaximum = moment(dateSelected + ' ' + timeMaximum).format()
            const changeData = intervals(timeMinimum, timeMaximum)
            setAllAvailableTime(changeData)
        } else {
            setCustomDate(false)
            formik.values.pickupDay = ''
            setAllAvailableTime([{ value: '', show: `Select A Time` }])
        }
    }, [formik.values.pickupDay])

    useEffect(() => {
        if (responseStatusAppointment) {
            if (responseStatusAppointment.from === 'appointment') {
                formik.setSubmitting(false)
                setIsLoading(false)
                if (responseStatusAppointment.status === 'success')
                    toggleFullScreenPopup(false)
            }
        }
    }, [responseStatusAppointment])

    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new'
                    ? 'ADD NEW APPOINTMENT'
                    : `EDIT APPOINTMENT:`
            }
            open={data.popup == 'Comment' ? false : data.popup}
            handleClose={() => toggleFullScreenPopup(false)}
        >
            {console.log(data, 'dataaa')}
            <div className="addUserModal">
                <div className="fspBody">
                    {formik.isSubmitting ? <LinearProgress /> : null}
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <form onSubmit={formSubmit} autoComplete="nofill">
                            {data.status === 'edit' && (
                                <div>
                                    <div className="row">
                                        {Object.values(
                                            mapData(EditAppointment)
                                        )}
                                    </div>
                                </div>
                            )}
                            {formik.values.local_pickup_check ? (
                                <div className="checkout">
                                    <div className="schedule">
                                        <h4 className="checkoutHead">
                                            {'Select a Pickup Date' + ':'}
                                        </h4>
                                        <div className="chCnt d-flex justify-content-start align-items-center">
                                            <div className="selectDate d-flex justify-content-center align-items-center">
                                                <input
                                                    name="pickupDay"
                                                    checked={
                                                        formik?.values
                                                            ?.pickupDay >=
                                                            dateFormatFrontOnlyDate(
                                                                today
                                                            ) &&
                                                        formik?.values
                                                            ?.pickupDay != ''
                                                            ? true
                                                            : false
                                                    }
                                                    type="radio"
                                                    id={`schedule_1`}
                                                    hidden
                                                ></input>
                                                <label>
                                                    <ListItem
                                                        button
                                                        onClick={() =>
                                                            setDateCalendar(
                                                                !dateCalendar
                                                            )
                                                        }
                                                    >
                                                        {customDate ? (
                                                            <p>
                                                                {formik?.values
                                                                    ?.pickupDay >=
                                                                dateFormatFrontOnlyDate(
                                                                    today
                                                                )
                                                                    ? formik
                                                                          .values
                                                                          .pickupDay
                                                                    : dateFormatFrontOnlyDate(
                                                                          today
                                                                      )}
                                                            </p>
                                                        ) : (
                                                            <>
                                                                <p>
                                                                    Choose Date
                                                                </p>
                                                                <span>
                                                                    (
                                                                    {
                                                                        'Custom Date'
                                                                    }
                                                                    )
                                                                </span>
                                                            </>
                                                        )}
                                                    </ListItem>
                                                </label>

                                                {mapData([
                                                    {
                                                        label: 'Custom Date',
                                                        placeholder:
                                                            'Appointment',
                                                        disablePast: true,
                                                        open: dateCalendar,
                                                        onClose: () =>
                                                            setDateCalendar(
                                                                false
                                                            ),
                                                        class: 'col-md-4 col-sm-6 col-12 d-none',
                                                        type: 'dateWithCustomPicker',
                                                        name: 'pickupDay',
                                                        minDate:
                                                            moment(
                                                                today
                                                            ).format(
                                                                'YYYY-MM-DD'
                                                            ),
                                                        minDateMessage: `${'date should be greater than the current date'} - ${dateTimeFormatFunction(
                                                            tomorrow
                                                        )}`,
                                                        shouldEnableDate:
                                                            single_appointment.records
                                                                ?.at(0)
                                                                ?.local_pickup_dates?.split(
                                                                    ','
                                                                ),
                                                        // .map(
                                                        //     (d) =>
                                                        //         new Date(parseInt(d))
                                                        //             .toISOString()
                                                        //             .split('T')[0],
                                                        // ),
                                                        showTodayButton: false,
                                                        formik: formik,
                                                    },
                                                ])}
                                            </div>
                                        </div>

                                        <p className="scheduleError">
                                            {formik.errors.pickupDay &&
                                                formik.touched.pickupDay &&
                                                formik.errors.pickupDay}
                                        </p>

                                        {formik.values.pickupDay &&
                                            allAvailableTime.length > 0 && (
                                                <>
                                                    <h4 className="checkoutHead">
                                                        {'Select A Pickup Time' +
                                                            ':'}
                                                    </h4>
                                                    <div className="chCnt timeSlots d-flex justify-content-start align-items-center flex-wrap">
                                                        {allAvailableTime
                                                            .filter(
                                                                (
                                                                    availableTimeUnit
                                                                ) =>
                                                                    formik
                                                                        .values
                                                                        .pickupDay <=
                                                                    moment().format(
                                                                        'MM-DD-YYYY'
                                                                    )
                                                                        ? moment(
                                                                              availableTimeUnit.value,
                                                                              'HH:mm'
                                                                          )
                                                                              .format(
                                                                                  'HH:mm'
                                                                              )
                                                                              .valueOf() >=
                                                                          moment()
                                                                              .format(
                                                                                  'HH:mm'
                                                                              )
                                                                              .valueOf()
                                                                        : availableTimeUnit.value
                                                            )
                                                            .map(
                                                                (
                                                                    data,
                                                                    index
                                                                ) => {
                                                                    let dateArr =
                                                                        formik.values.pickupDay.split(
                                                                            '-'
                                                                        )
                                                                    let slotLeft =
                                                                        single_appointment
                                                                            .records?.[0]
                                                                            ?.local_pickup_appt_per_slot -
                                                                        all_appointments_auction.records?.filter(
                                                                            (
                                                                                apt
                                                                            ) =>
                                                                                apt.appointmentTime ==
                                                                                    new Date(
                                                                                        `${dateArr[2]}/${dateArr[0]}/${dateArr[1]} ${data.value}`
                                                                                    ).toISOString() &&
                                                                                apt.status !=
                                                                                    'open'
                                                                        ).length
                                                                    return (
                                                                        slotLeft >
                                                                            0 && (
                                                                            <div
                                                                                className="selectDate d-flex justify-content-center align-items-center"
                                                                                key={
                                                                                    index
                                                                                }
                                                                            >
                                                                                <input
                                                                                    name="pickupTime"
                                                                                    value={
                                                                                        data.value
                                                                                    }
                                                                                    onChange={
                                                                                        formik.handleChange
                                                                                    }
                                                                                    type="radio"
                                                                                    id={`scheduleTime_${index}`}
                                                                                    hidden
                                                                                ></input>
                                                                                <label
                                                                                    htmlFor={`scheduleTime_${index}`}
                                                                                >
                                                                                    <ListItem
                                                                                        button
                                                                                    >
                                                                                        <p>
                                                                                            {
                                                                                                data.show
                                                                                            }
                                                                                        </p>
                                                                                        <hr />
                                                                                        <p>
                                                                                            {
                                                                                                slotLeft
                                                                                            }{' '}
                                                                                            slot(s)
                                                                                            left
                                                                                        </p>
                                                                                    </ListItem>
                                                                                </label>
                                                                            </div>
                                                                        )
                                                                    )
                                                                }
                                                            )}
                                                    </div>
                                                    <p className="scheduleError">
                                                        {
                                                            formik.errors
                                                                .pickupTime
                                                        }
                                                    </p>
                                                </>
                                            )}
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                            <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                <SecondaryButton
                                    label="Cancel"
                                    onClick={() => toggleFullScreenPopup(false)}
                                />
                                <PrimaryButton
                                    type="submit"
                                    disabled={
                                        data.status === 'new' &&
                                        (!formik.values.pickupDay ||
                                            !formik.values.pickupTime)
                                            ? true
                                            : false
                                    }
                                    label={
                                        data.status === 'new'
                                            ? 'Submit'
                                            : 'Update'
                                    }
                                />
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default AppointmentManage
